export default __webpack_public_path__ + "static/a1_blog_header_banner_bg-43672800d6a1f45e277db7d98e72e98d.webp";